export default "__VITE_ASSET__BBsirc5m__"